import type { ChangeDateRevision, ChangeFormField } from '../../types/changes';

export type DateRevisionLookup = Record<string, ChangeDateRevision> | null | undefined;

export function dateRevisionKey(field: Pick<ChangeFormField, 'id' | 'native_key'>): string {
  return field.native_key || `extra:${field.id}`;
}

export function dateRevisionOf(
  revisions: DateRevisionLookup,
  field: Pick<ChangeFormField, 'id' | 'native_key'>,
): ChangeDateRevision | undefined {
  if (!revisions) return undefined;
  return revisions[dateRevisionKey(field)];
}

export function nativeDateRevisionOf(
  revisions: DateRevisionLookup,
  nativeKey: string,
): ChangeDateRevision | undefined {
  if (!revisions) return undefined;
  return revisions[nativeKey];
}
